module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/odesa-dnipro-holovnyi-97746620dd7d9e2f4c27ad5af0d0336a.png";